import React from 'react';

export const DocumentTypeIcon = () => (
  <svg height="13.626" viewBox="0 0 13.5 13.626" width="13.5" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M293.667,101.667h.007M293.667,99H297a1.328,1.328,0,0,1,.943.391l4.667,4.667a1.333,1.333,0,0,1,0,1.885l-4.667,4.667a1.333,1.333,0,0,1-1.885,0l-4.667-4.667A1.327,1.327,0,0,1,291,105v-3.333A2.667,2.667,0,0,1,293.667,99Z"
      fill="none"
      id="Path_643"
      stroke="#7f7f7f"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      transform="translate(-290.25 -98.25)"
    />
  </svg>
);
